webpackJsonp([13],{

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(833),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ls = __webpack_require__(27);
var configurations = __webpack_require__(33);
var cloudinarySettings = configurations.cloudinary_settings;
var cloud_name = configurations.cloudinary_cloudName;
var upload_preset = configurations.cloudinary_preset;

/* harmony default export */ __webpack_exports__["a"] = ({
  //
  data: function data() {
    return {
      uploadedImgUrl: ''
    };
  },

  //
  created: function created() {
    // two set interval cz -> a page can have 2 search.
    // 1
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    // 2
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    var str = ls.get('thumbnailImgUrl');
    var id = str.split('/')[str.split('/').length - 1];
    this.uploadedImgUrl = 'https://res.cloudinary.com/' + cloud_name + '/image/upload/w_600,h_400,c_fill,' + cloudinarySettings + '/' + upload_preset + '/' + id;
    console.log("[uploadedImgUrl] => ", this.uploadedImgUrl);
    //
  }
});

/***/ }),

/***/ 648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__ = __webpack_require__(544);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//

//
/* harmony default export */ __webpack_exports__["default"] = ({
  //
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixin_uploadImage__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapMutations */])(['goTo_uploadImage_5'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])([])),
  created: function created() {
    window.thisOfVueComp = this;
  },
  mounted: function mounted() {}
  // this.$store.commit('getSpotTypeSuggestions_fromLocalStorage')

  //

});

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Step 4/5")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }],
    attrs: {
      "height": "100",
      "width": "100"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n\n    from previous route => " + _vm._s(_vm.$route.query) + " "), _c('br'), _c('br'), _vm._v("\n    location from previous route [parsed] => " + _vm._s(JSON.parse(_vm.$route.query.shareSpotLocation)) + " "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.goTo_uploadImage_5({
          url: _vm.$route.query.url,
          resourceType: _vm.$route.query.resourceType,
          publicId: _vm.$route.query.publicId,
          //
          createdAt: _vm.$route.query.createdAt,
          //
          caption: _vm.$route.query.caption,
          emotionalAppeal: JSON.parse(_vm.$route.query.emotionalAppeal),
          //
          shareSpotLocation: JSON.parse(_vm.$route.query.shareSpotLocation), //parsed
          hasGeohash: _vm.$route.query.hasGeohash,
          //
          spotType: _vm.$store.state.uploadImage_4.selectedSpotType_uploadImage,
          anyoneCanVisitThisSpot: _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage
        })
      }
    }
  }, [_vm._v("\n      next\n    ")])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/13.a1d916303c130ce8fd13.js